import { useDispatch } from "react-redux";
import { TextInput, Button } from "../../components";
import { HiUser } from "react-icons/hi";
import { RiLockPasswordFill } from "react-icons/ri";
import { loginModal, registerModal } from "../../state/action";

import FaceBookImg from "../../assets/facebook.JPG";
import GoogleImg from "../../assets/google.png";
import TwitterImg from "../../assets/twitter.JPG";
import Logo from "../../assets/SC.png";
import { Link } from "react-router-dom";
import "./style.css";


const PureLoginForm = ({page}) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="hidden lg:block">
        <h3 className="text-xl"> Welcome Back </h3>
      </div>
      <div className="flex lg:hidden justify-center">
        <img src={Logo} />
      </div>
      <form className="mt-10 text-center">
        <div className="mt-10">
          <TextInput
            placeholder="Username"
            type="text"
            size="middle"
            name="username"
            label=""
            className="form-input"
            icon={<HiUser />}
          />
        </div>
        <div className="mt-10 mb-2">
          <TextInput
            placeholder="*********"
            type="text"
            size="middle"
            name="password"
            label=""
            className="form-input"
            icon={<RiLockPasswordFill />}
          />
        </div>
        <div className="text-right">
          <p>Forgot Password?</p>
        </div>
        <div>
          <Button
            type="primary"
            className="mt-10 primary-color button-secondary w-full"
            title="Sign In"
            style={{borderRadius: 5}}
          />
        </div>
        <div className="mt-10">
          <p className="text-xl">Or</p>
          <div className="flex justify-evenly mt-10">
            <img src={GoogleImg} />
            <img src={FaceBookImg} />
            <img src={TwitterImg} />
          </div>
          <div className="mt-20">
            <p className="text-lg lg:text-lg">
              Dont have an Account?{" "}
              {page ? <Link to="/register-page">
                Sign Up
              </Link> :  <a
                onClick={() => {
                  dispatch(loginModal());
                  dispatch(registerModal());
                }}
              >
                Sign Up
              </a>}
            </p>
          </div>
        </div>
      </form>
    </>
  );
};

export default PureLoginForm;
